import Modal from "../../shared/Modal";
import "./ModalConfirm.css";
import ActionButton from "../../common/ActionButton";
import { Button } from "../../../ds2/components";

type ModalConfirmProps = {
  title?: string;
  text: string;
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalConfirm = ({
  title = "Please Note",
  text,
  isOpen,
  onClose,
  onContinue,
}: ModalConfirmProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={true}
        allowClickout={true}>
        <div id="modal-confirm">
          <div className="modal-confirm-title">{title}</div>

          <div className="modal-confirm-content">
            <p>{text}</p>
          </div>

          <div className="modal-confirm-footer">
            <div className="modal-confirm-buttons">
              <Button
                onClick={onClose}
                label="Cancel"
                variant="secondary"
              />

              <Button
                onClick={() => onContinue()}
                label="Continue"
                variant="primary"
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalConfirm;
